import { CHECKLIST, checkProgress } from '../lib/checklist';

interface Props {
  checks: Record<string, boolean>;
  onToggle: (id: string, on: boolean) => void;
}

export function Checklist({ checks, onToggle }: Props) {
  const pct = Math.round(checkProgress(checks) * 100);
  return (
    <section className="card" aria-labelledby="checklist-h">
      <h2 id="checklist-h">Checklist <span className="muted">({pct}% done)</span></h2>
      <progress value={pct} max={100} aria-label="Checklist progress" />
      {CHECKLIST.map((g) => (
        <fieldset key={g.id}>
          <legend>{g.title}</legend>
          {g.items.map((i) => (
            <label key={i.id} className="check">
              <input type="checkbox" checked={!!checks[i.id]} onChange={(e) => onToggle(i.id, e.target.checked)} />
              <span>{i.text}</span>
            </label>
          ))}
        </fieldset>
      ))}
    </section>
  );
}
